export const plPL = {
  app: {
    categories: {
      convectors: 'Grzejniki konwektorowe',
      decorative: 'Grzejniki dekoracyjne',
      electric: 'Grzejniki elektryczne',
      panels: 'Grzejniki panelowe',
      towel: 'Grzejniki łazienkowe',
    },
    categoryLabel: 'Kategoria',
    categoryPlaceholder: 'Wybierz kategorię',
    errorCategories: 'Nie udało się wczytać kategorii',
    errorPanels: 'Nie udało się wczytać grzejników',
    loadingCategories: 'Ładowanie kategorii...',
    loadingPanels: 'Ładowanie grzejników...',
    panelLabel: 'Grzejniki',
    panelPlaceholder: 'Wybierz grzejnik',
    titles: {
      convectors: 'Kalkulator grzejników konwektorowych',
      decorative: 'Kalkulator grzejników dekoracyjnych',
      electric: 'Kalkulator grzejników elektrycznych',
      panels: 'Kalkulator grzejników panelowych',
      towel: 'Kalkulator grzejników łazienkowych',
    },
  },
  calc: {
    actionButton: 'Wyświetl pozycje spełniające powyższe wybrane parametry',
    boost: 'Tryb BOOST',
    calculateRequiredButton: 'Oblicz wymaganą wydajnosć cieplną',
    calculating: 'Obliczanie...',
    comfort: 'Tryb komfort',
    downloadLabel: 'Pobierz dane ({count})',
    emptyResults: 'Brak wyników',
    errorMatch: 'Nie udało się obliczyć wyników',
    errorTypes: 'Nie udało się wczytać typów grzejników',
    flowTemp: 'Temperatura zasilania °C',
    height: 'Wysokość',
    length: 'Długość',
    loadingTypes: 'Ładowanie typów...',
    modeLabel: 'Tryb',
    modes: {
      cooling: 'Chłodzenie',
      heating: 'Ogrzewanie',
    },
    radiatorType: 'Typ grzejnika',
    requiredWatts: 'Obciążenie cieplne (wymagana ilość ciepła)',
    resultsMessage: '{count} pozycji dostępnych dla wybranych opcji',
    returnTemp: 'Temperatura powrotu °C',
    roomTemp: 'Temperatura pomieszczenia °C',
    selectAllLabel: 'Wybierz wszystkie pozycje',
    selectItemLabel: 'Wybierz pozycję do pobrania',
    selectPanel: 'Wybierz typ grzejnika do obliczeń',
    standby: 'Tryb czuwania',
    tableHeaders: {
      calculatedWattage: 'Wydajność',
      co2Equivalent: 'Ekwiwalent CO2 na kg materiału',
      depth: 'Głębokość [mm]',
      description: 'Opis',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Wysokość [mm]',
      itemId: 'Numer katalogowy',
      length: 'Długość [mm]',
      waterContent: 'Pojemność wodna',
      weight: 'Ciężar',
    },
    title: 'Obliczenia',
    tolerance: 'Tolerancja',
    typeCooling: 'Chłodzenie',
    typeGroupLabel: 'Typ',
    typeHeating: 'Ogrzewanie',
  },
  castIronRadiator: {
    description: 'Oblicz moc cieplną dla grzejników żeliwnych członowych.',
    elements: 'Liczba członów',
    flowTemp: 'Temperatura zasilania',
    resultLabel: 'Moc cieplna',
    returnTemp: 'Temperatura powrotu',
    roomTemp: 'Temperatura pomieszczenia',
    select: 'Wybierz',
    type: 'Typ grzejnika',
  },
  existingRadiator: {
    description:
      'Ten kalkulator służy wyłącznie celom informacyjnym. Przed zakupem grzejnika zawsze skonsultuj się z profesjonalnym doradcą w celu wykonania dokładnych obliczeń.',
    height: 'Wysokość grzejnika',
    length: 'Długość grzejnika',
    resultLabelTemplate:
      'Wymagana wydajność cieplna (moc) grzejnika, obliczona dla temperatury systemu {temp}',
    select: 'Wybierz',
    temperature: 'Temperatura systemu',
    type: 'Typ grzejnika',
  },
  matrixCalc: {
    axisHeight: 'Wysokość (mm)',
    axisLength: 'Długość (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Widok',
    exportExcel: 'Eksportuj do Excela',
    exportPdf: 'Eksportuj do PDF',
    print: 'Drukuj',
    hideOutOfRange: 'Ukryj pozycje spoza zakresu',
    showAll: 'Pokaż wszystko',
    loading: 'Loading...',
    lockHeight: 'Wysokość',
    lockLabel: 'Zablokuj wymiar',
    lockLength: 'Długość',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Oblicz',
    clearButton: 'Wyczyść wszystko',
    fields: {
      ceilingHeight: 'Wysokość pomieszczenia',
      doorInsulation: 'Izolacja drzwi',
      floorInsulation: 'Izolacja podłogi',
      glazingArea: 'Wybierz procentowy udział przeszkleń w powierzchni ściany',
      glazingMode: 'Wybierz procentowy udział przeszkleń w powierzchni ściany',
      glazingQuality: 'Wybierz standard wykonania przeszkleń',
      length: 'Długość',
      outerWalls: 'Ilość ścian zewnętrznych',
      projectedDesignTemp: 'Wybierz strefę klimatyczną, w której znajduje się budynek',
      roofInsulation: 'Izolacja dachu',
      roomArea: 'Powierzchnia pomieszczenia',
      roomFloor: 'Podaj kondygnację pomieszczenia',
      roomInsulation: 'Wybierz izolację pomieszczenia',
      roomPreset: 'Domyślne wymiary pomieszczenia',
      roomTemperature: 'Temperatura pomieszczenia',
      roomType: 'Typ pomieszczenia',
      uncertaintyFactor: 'Współczynnik',
      ventilation: 'Poziom wentylacji',
      wallInsulation: 'Izolacja ścian',
      width: 'Szerokość',
      windConditions: 'Wybierz warunki wietrzności',
      windowInsulation: 'Izolacja okien',
    },
    intro: 'Oblicz obciążenie cieple (straty ciepła) w pomieszczeniu, aby dobrać właściwy produkt',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Więcej niż 20%',
        low: 'Mniej niż 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Powyżej 20%',
        below_10: 'Poniżej 10%',
        from_10_to_20: 'Od 10% do 20%',
        no_windows: 'Bez okien',
      },
      insulationValue: {
        good: 'Dobra',
        medium: 'Średnia',
        poor: 'Słaba',
        very_good: 'Bardzo dobra',
      },
      qualityValue: {
        modern_excellent: 'Nowoczesne, bardzo dobra efektywność energetyczna',
        modern_good: 'Nowoczesne, dobra efektywność energetyczna',
        old_poor: 'Stare, bardzo słaba efektywność energetyczna',
        traditional_medium: 'Tradycyjne, średnia efektywność energetyczna',
      },
      roomValue: {
        bathroom_24: 'Łazienka (+24 °C)',
        bedroom_20: 'Sypialnia (+20 °C)',
        garage_12: 'Garaż (+12 °C)',
        livingroom_22: 'Salon (+22 °C)',
        storage_16: 'Magazyn (+16 °C)',
        extra_1: 'Hol (+18 °C)',
        extra_2: 'Garderoba (+8 °C)',
      },
      select: 'Wybierz',
      storeyValue: {
        ground_multi: 'Parter (budynek wielokondygnacyjny)',
        ground_single: 'Parter (budynek jednokondygnacyjny)',
        interim: 'Kondygnacja pośrednia',
        top_multi: 'Ostatnia kondygnacja (budynek wielokondygnacyjny)',
      },
      temp: {
        climate_zone_1: 'Strefa klimatyczna I (-12 °C)',
        climate_zone_2: 'Strefa klimatyczna II (-14 °C)',
        climate_zone_3: 'Strefa klimatyczna III (-16 °C)',
        climate_zone_4: 'Strefa klimatyczna IV (-18 °C)',
        climate_zone_5: 'Strefa klimatyczna V (-20 °C)',
        climate_zone_6: 'Strefa klimatyczna VI (-22 °C)',
        climate_zone_7: 'Strefa klimatyczna VII (-24 °C)',
        climate_zone_8: 'Strefa klimatyczna VIII (-26 °C)',
      },
      windInfluence: {
        normal: 'Normalne',
        strong: 'Silne',
        weak: 'Słabe',
      },
    },
    roomPresets: {
      bathroom: 'Łazienka',
      bedroom: 'Sypialnia',
      garage: 'Garaż',
      kitchen: 'Kuchnia',
      living: 'Salon',
      storage: 'Magazyn',
    },
    sections: {
      dimensions: 'Wymiary pomieszczenia',
      insulation: 'Izolacja',
      placement: 'Usytuowanie',
      result: 'Wynik',
      temps: 'Temperatury',
      ventilation: 'Wentylacja',
    },
    title: 'Kalkulator obciążenia cieplnego (strat ciepła) w pomieszczeniu',
    units: {
      celsius: '°C',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Użyj',
  },
  slider: {
    from: 'Od',
    to: 'Do',
    value: 'Wartość',
  },
}
